module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "header_wrap"
  }, [_c('div', {
    staticClass: "header_wrap-left"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("戻る")])]), _c('div', {
    staticClass: "header_wrap-center"
  }, [_c('button', {
    staticClass: "draft-save-btn",
    on: {
      "click": function($event) {
        _vm.saveDraft()
      }
    }
  }, [_vm._v("下書保存")])]), _c('div', {
    staticClass: "header_wrap-right"
  }, [_c('button', {
    staticClass: "hand_over_btn",
    on: {
      "click": function($event) {
        _vm.setHandOver()
      }
    }
  }, [_vm._v("渡す")])])]), [_c('div', {
    staticClass: "es_mycard_download_wrap"
  }, [_c('div', {
    staticClass: "es_mycard"
  }, [_c('div', {
    staticClass: "es_mycard_background"
  }, [_c('img', {
    attrs: {
      "src": _vm.getBackgroundImageByImageName(_vm.card.background_path)
    }
  })]), _c('div', {
    staticClass: "get_user_box"
  }, [_c('div', {
    staticClass: "get_user_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserImage(_vm.card.get_user_image)
    }
  })]), _c('div', {
    staticClass: "get_user_box_body"
  }, [_c('p', {
    staticClass: "get_user_box_body-role"
  }, [_vm._v(_vm._s(_vm.card.get_user_shop_name))]), _c('p', {
    staticClass: "get_user_box_body-name"
  }, [_vm._v(_vm._s(_vm.card.get_user_name))])])]), _c('div', {
    staticClass: "give_user_box"
  }, [_c('div', {
    staticClass: "give_user_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserImage(_vm.card.give_user_image)
    }
  })]), _c('div', {
    staticClass: "give_user_box_body"
  }, [_c('p', {
    staticClass: "give_user_box_body-role"
  }, [_vm._v(_vm._s(_vm.card.give_user_shop_name))]), _c('p', {
    staticClass: "give_user_box_body-name"
  }, [_vm._v(_vm._s(_vm.card.give_user_name))])])]), _c('div', {
    staticClass: "comment_box"
  }, [_c('div', {
    staticClass: "comment_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCharacter1ImageByImageName(_vm.card.character_1_folder_path, _vm.card.character_1_path)
    }
  })]), _c('div', {
    staticClass: "comment_box_body"
  }, [_c('p', {
    staticClass: "comment_box_body-text font_size",
    class: _vm.setClassCommentFontSize(),
    domProps: {
      "textContent": _vm._s(_vm.card.comments)
    }
  })])]), _c('div', {
    staticClass: "character_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCharacter2ImageByImageName(_vm.card.character_2_path)
    }
  })])]), _c('div', {
    staticClass: "philosophy"
  }, [_c('div', {
    staticClass: "philosophy_list"
  }, [_c('ul', [(_vm.card.idea_peace_ming) ? _c('li', [_vm._v("安心")]) : _vm._e(), (_vm.card.idea_sincere) ? _c('li', [_vm._v("誠実")]) : _vm._e(), (_vm.card.idea_excitement) ? _c('li', [_vm._v("感動")]) : _vm._e(), (_vm.card.idea_comfortable) ? _c('li', [_vm._v("快適")]) : _vm._e(), (_vm.card.idea_creation) ? _c('li', [_vm._v("創造")]) : _vm._e(), (_vm.card.idea_civility) ? _c('li', [_vm._v("礼節")]) : _vm._e(), (_vm.card.idea_imagination) ? _c('li', [_vm._v("想像")]) : _vm._e(), (_vm.card.idea_sympathy) ? _c('li', [_vm._v("感応")]) : _vm._e(), (_vm.card.idea_expression) ? _c('li', [_vm._v("表現")]) : _vm._e(), (_vm.card.idea_challenge_dream) ? _c('li', [_vm._v("挑夢")]) : _vm._e()])])])])], (_vm.isHandOverCardCompleteModal) ? [_c('div', {
    staticClass: "hand_over_modal"
  }, [_c('div', {
    staticClass: "hand_over_modal--overlay"
  }), _c('div', {
    staticClass: "hand_over_modal--main"
  }, [_c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("カードを渡しました")]), _vm._m(0), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('button', {
    staticClass: "modal-main__buttons--transition",
    on: {
      "click": function($event) {
        _vm.goEsMycardList()
      }
    }
  }, [_vm._v("みんなのカード一覧へ")])])])])] : _vm._e(), (_vm.isHandOverCardErrorModal) ? [_c('div', {
    staticClass: "hand_over_modal"
  }, [_c('div', {
    staticClass: "hand_over_modal--overlay"
  }), _c('div', {
    staticClass: "hand_over_modal--main"
  }, [_c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("エラーが発生したニャン。(絵文字など入ってないかニャン？)")]), _vm._m(1), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('button', {
    staticClass: "modal-main__buttons--transition",
    on: {
      "click": function($event) {
        _vm.goCancel()
      }
    }
  }, [_vm._v("閉じる")])])])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-main__cartoon"
  }, [_c('img', {
    staticClass: "modal-main__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_13.png"),
      "alt": "ねこ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-main__cartoon"
  }, [_c('img', {
    staticClass: "modal-main__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_13.png"),
      "alt": "ねこ"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2194bcb1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/es-mycard-preview.pug
// module id = 1381
// module chunks = 1